import React from 'react';
import DataTables from 'components/dataTables';
import { connect } from 'react-redux';
import { FailedUrlsAction } from 'redux/actions';
import { DateFormat } from 'hooks';
import PageSpinner from 'components/PageSpinner';
import TableCustomHeader from 'components/dataTables/tableCustomHeader';
import { Input,Col } from 'reactstrap';
import DateRangePickerComp from 'components/DatePicker/DateRangePicker';
import moment from 'moment';

const FrequentlyUsedUrls = (props) => {
   
    const [defaultRange] = React.useState(
        {
            startDate: moment().toDate(),
            endDate: moment().toDate(),
            key: 'selection'
        }
    );

    const [dateRange, setDateRange] = React.useState(defaultRange);
    const [keyword, setKeyword] = React.useState('');
    const [pagination, setPagination] = React.useState({
        page: 0,
        page_limit: 10,
    });
    const [order, setOrder] = React.useState({
        order_by: `created_at`,
        direction: 'desc'
    });

    const handleDateChange = (date) => {
        setDateRange(date);
    }

    React.useEffect(() => {
        handleSearch();
    }, [pagination, order])


    const handleSearch = () => {
        const startDateString = dateRange.startDate ? moment(dateRange.startDate).format('YYYY-MM-DD') : '';
        const endDateString = dateRange.endDate ? moment(dateRange.endDate).format('YYYY-MM-DD') : '';
        const payload = { 
            start_date: startDateString, 
            end_date: endDateString,
            page: pagination.page,
            page_limit: pagination.page_limit,
            keyword:keyword
        };
        props.getFailedUrlsFrequency(payload);

    }



    const columns = () => {
        const cols = [
            {
                name: "failed_host",
                label: "Host",
            },
            {
                name: "total_metas",
                label: "Total Searches",
            },
            {
                name: "host_search_count",
                label: "Host Searched",
            },
            
            {
                name: "frequency",
                label: "Frequently Used ",
            }
        ];
        return cols.map((column, index) => {
            return {
                label: column.label,
                name: column.name,
                options: {
                    display: (column.name === 'device_os') ? false : true,
                    customHeadRender: (columnMeta, updateDirection) => {
                        return <TableCustomHeader key={index} itemkey={index} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                    },
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (tableMeta.columnData.name === 'frequency')?`${value} %`:value;
                    }
                }
            }
        })
    }


    const options = {
        tableId: 'datatable',
        filterType: 'checkbox',
        search: false,
        responsive: "simple",
        filter: false,
        download: false,
        print: false,
        selectableRows: 'none',
        viewColumns: false,
        count: props.totalCount,
        serverSide: (props.serverSide !== undefined) ? props.serverSide : true,
        page: pagination.page,
        rowsPerPage: pagination.page_limit,
        setRowProps: (row, dataIndex, rowIndex) => {
            return {
                style: (DateFormat(row[8], 'MM-DD-YYYY') && DateFormat(row[7], 'MM-DD-YYYY') !== DateFormat(row[8], 'MM-DD-YYYY')) ? { background: '#00aee463' } : { background: 'auto' },
            };
        },
        onColumnSortChange: (changedColumn) => {
            setOrder({
                order_by: changedColumn,
                direction: (order.direction === 'asc') ? 'desc' : 'asc'
            })
        },
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setPagination({
                        page_limit: pagination.page_limit,
                        page: tableState.page
                    })
                    break;
                case 'changeRowsPerPage':
                    setPagination({
                        page_limit: tableState.rowsPerPage,
                        page: 0,
                    })
                    break;
                default:
                    break
            }
        }
    };

    return (
        <div>

            <div>

            <DateRangePickerComp handleDateChange={handleDateChange} handleSearch={handleSearch} defaultRange={defaultRange} >
                <Col lg={3} md={6} sm={6} xs={8} >
                    <Input
                        type="text"
                        name="keyword"
                        id="keyword"
                        onChange={(e)=>{
                            setKeyword(e.target.value)
                        }}
                        autoComplete={'off'}
                        value={(keyword) ? keyword : ''}
                        placeholder={'Search by domain'}
                        style={{ width: 250, marginBottom: 10 }}
                    />
                </Col>
            </DateRangePickerComp>
        </div>


            {props.isLoading ? <PageSpinner />
                : <DataTables data={props.failedUrlsFrequency} columns={columns()} options={options} />
            }
        </div>
    );
}


const mapStateToProps = (state) => ({
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    totalCount: (state.failedUrls && state.failedUrls.urlsFrequency && state.failedUrls.urlsFrequency.totalCount) ? state.failedUrls.urlsFrequency.totalCount : 0,
    failedUrlsFrequency: (state.failedUrls && state.failedUrls.urlsFrequency && state.failedUrls.urlsFrequency.data) ? state.failedUrls.urlsFrequency.data : [],
});
const mapDispatchToProps = (dispatch) => ({
    getFailedUrlsFrequency: (payload) => dispatch(FailedUrlsAction.getFailedUrlsFrequency(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FrequentlyUsedUrls);
